import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useFacilityLessonBookingDays_facility$key } from "./__generated__/useFacilityLessonBookingDays_facility.graphql";

export const useFacilityLessonBookingDays = (
  facilityRef: useFacilityLessonBookingDays_facility$key | null
) => {
  const facility = useFragment(
    useFacilityLessonBookingDaysFragmentString,
    facilityRef
  );
  const bookingWindowDays = facility?.club?.supportsPublic
    ? facility?.publicLessonsPermissionSet?.bookingWindowDays || 30
    : facility?.privateLessonsPermissionSet?.bookingWindowDays || 30;

  return bookingWindowDays;
};

const useFacilityLessonBookingDaysFragmentString = graphql`
  fragment useFacilityLessonBookingDays_facility on Facility {
    club {
      supportsPublic
    }
    privateLessonsPermissionSet {
      bookingWindowDays
    }
    publicLessonsPermissionSet {
      bookingWindowDays
    }
  }
`;
